import * as React from "react"
const SavedFull = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill="#202327"
      stroke="#202327"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M2.333 10.489V5.663c0-2.12 0-3.18.684-3.838C3.7 1.167 4.8 1.167 7 1.167s3.3 0 3.983.658c.684.658.684 1.718.684 3.838v4.826c0 1.345 0 2.017-.451 2.258-.873.466-2.51-1.09-3.288-1.557-.451-.272-.677-.408-.928-.408-.25 0-.476.136-.927.408-.778.468-2.416 2.023-3.289 1.557-.45-.24-.45-.913-.45-2.258Z"
    />
  </svg>
)
export default SavedFull
